/* eslint-disable no-unused-vars */
import { Platform } from 'react-native';
import { EnvVars } from '../constants/EnvConfig';
let Sentry;
if (Platform.OS === 'web') {
  Sentry = require('@sentry/react');
} else {
  Sentry = require('@sentry/react-native');
}

export { log, logError, debug };

const Reset = '\x1b[0m';
const Bright = '\x1b[1m';
const Dim = '\x1b[2m';
const Underscore = '\x1b[4m';
const Blink = '\x1b[5m';
const Reverse = '\x1b[7m';
const Hidden = '\x1b[8m';

const FgBlack = '\x1b[30m';
const FgRed = '\x1b[31m';
const FgGreen = '\x1b[32m';
const FgYellow = '\x1b[33m';
const FgBlue = '\x1b[34m';
const FgMagenta = '\x1b[35m';
const FgCyan = '\x1b[36m';
const FgWhite = '\x1b[37m';

const BgBlack = '\x1b[40m';
const BgRed = '\x1b[41m';
const BgGreen = '\x1b[42m';
const BgYellow = '\x1b[43m';
const BgBlue = '\x1b[44m';
const BgMagenta = '\x1b[45m';
const BgCyan = '\x1b[46m';
const BgWhite = '\x1b[47m';

function prefix(label, message) {
  return `${new Date().toISOString()} [${label}] ${message}`;
}

function log(output, details) {
  const message = prefix('ptf', output);
  if (EnvVars.consoleLog) {
    if (details) {
      console.log(FgWhite, message, details);
    } else {
      console.log(FgWhite, message);
    }
  }
}

function logError(output, details) {
  const message = prefix('ptf', output);
  if (EnvVars.useSentry) {
    if (details instanceof Error) {
      Sentry.captureException(details);
    } else {
      Sentry.captureException(new Error(message), { contexts: { errorDetail: details } });
    }
  }

  if (EnvVars.consoleLog) {
    console.log(FgRed, message, details);
  }
}

function debug(output) {
  const message = prefix('ptf', output);
  if (EnvVars.debugLog) {
    console.log(FgYellow, message);
  }
}
